module.exports = __webpack_public_path__ + "media/images/header-bg-1-065abf13.png";